// extracted by mini-css-extract-plugin
module.exports = {"root":"IconEdit_root__3yhUl","pencil":"IconEdit_pencil__1WxJt"};